import NotificationForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    NotificationForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('notifications.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.notifications.show(this.$route.params.id).then(response => {
        this.data = JSON.parse(JSON.stringify(response))
        this.ready = true

        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.notifications.index'), route: {name: 'notifications-index'}},
          {label: this.$t('breadcrumbs.notifications.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateNotification(data) {
      API.notifications.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('notifications.edit.succesfullyUpdated'))
        this.$router.push({name: 'notifications-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
